import { Row as AntdRow, RowProps } from 'antd'

export const Row = (props: RowProps) => <AntdRow {...props} />
